import { html } from 'lit'
import { customElement } from 'lit/decorators.js'
import { RaygunElement } from '@src/js/common/rg-element.js'

@customElement('rg-nav')
export class RgNavigation extends RaygunElement {

  registerEvents() {
    return {
      'document.click': this.onDocumentClick,
      'document.keydown:esc': this.closeNavItems,
    }
  }

  closeNavItems = (excludeElement) => {
    this.querySlot('rg-nav-item').forEach(el => {
      if (el !== excludeElement) {
        el.toggleAttribute('open', false)
      }
    })
  }

  onDocumentClick = (event) => {
    event.stopPropagation()
    if (!this.contains(event.target)) {
      this.closeNavItems()
    }
  }

  onItemToggle = (event) => {
    if (!event.detail.open) return
    this.closeNavItems(event.target)
  }

  render() {
    return html`
      <nav>
        <ul class="primary-nav">
          ${ this.querySlot('aside') }
          ${ this.querySlot('rg-nav-item').map(child => {
            return html`
            <li
              class="navbar-item"
              @toggle="${this.onItemToggle}"
            >
              ${ child }
            </li>`
          }) }
        </ul>
      </nav>
    `;
  }
}
